import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../assets/css/about.css';
import '../assets/css/services.css';
import '../assets/css/warehousing.css';
import WhyChooseImg from '../assets/images/why-choose-up.jpeg';

export default function Warehousing() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Banner section matching Services styling */}
            <section className="vas-activity-banner">
                <div className="vas-banner-overlay"></div>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-12">
                            <div className="vas-banner-content">
                                <div className="vas-breadcrumb mb-3">
                                    <Link to="/" className="breadcrumb-link">Home</Link>
                                    <span className="breadcrumb-separator">›</span>
                                    <span className="breadcrumb-current">Warehousing</span>
                                </div>
                                <h1 className="vas-banner-title">Warehousing Solutions</h1>
                                <p className="vas-banner-subtitle">
                                    Smart, secure and efficient warehousing that keeps your supply chain moving forward.
                                </p>
                                <div className="vas-banner-divider"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Intro Section with Image */}
            <section className="warehousing-section py-5" id="warehousing">
                <div className="container">
                    <div className="row align-items-center">
                        {/* Image on Left */}
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="warehousing-image-wrapper">
                                <img
                                    src={require('../assets/images/warehouse.jpg')}
                                    alt="Modern Warehousing Facility"
                                    className="img-fluid rounded shadow-lg warehousing-main-image"
                                />
                                <div className="warehousing-badge">
                                    <div className="badge-icon">
                                        <i className="fas fa-warehouse"></i>
                                    </div>
                                    <div className="badge-text">
                                        <h4>30+</h4>
                                        <p>Years of Excellence</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Content on Right */}
                        <div className="col-lg-6">
                            <div className="warehousing-content">
                                <div className="section-label mb-3">
                                    <i className="fas fa-box-open me-2"></i>
                                    <span className="text-uppercase fw-bold">Warehousing Solutions</span>
                                </div>
                                <h2 className="promise-title">
                                    Smart, Secure & Efficient Warehousing
                                </h2>
                                {/* <h2 className="warehousing-title mb-4">
                                    Smart, Secure & Efficient <span className="text-primary">Warehousing</span>
                                </h2> */}
                                <p className="warehousing-description mb-4">
                                    At <strong>Triburg Freight Services LLC</strong>, warehousing is more than just storage - it's about creating a smart, secure, and efficient space that keeps your supply chain moving. With over 30 years of experience in Dubai's logistics industry, we've built warehousing solutions that combine reliability, innovation, and flexibility.
                                </p>
                                <p className="warehousing-description mb-4">
                                    In today's fast-paced world, warehousing isn't just about keeping products safe - it's about ensuring they're ready to move when you are. Whether you need short-term storage, long-term solutions, or specialized handling, Triburg Freight Services LLC delivers warehousing that adapts to your business needs.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Our Warehousing Solutions Section */}
            <section className="our-warehousing-solutions-section py-5">
                <div className="container">
                    {/* Section Header */}
                    <div className="row mb-5">
                        <div className="col-12 text-center">
                            <div className="solutions-header">
                                <span className="solutions-badge">
                                    <i className="fas fa-warehouse me-2"></i>
                                    Our Solutions
                                </span>
                                <h2 className="solutions-main-title mt-3">
                                    Our Warehousing Solutions
                                </h2>
                                <div className="title-underline mx-auto"></div>
                            </div>
                        </div>
                    </div>

                    {/* Solutions Grid */}
                    <div className="row g-4">
                        {/* Strategic Locations */}
                        <div className="col-lg-6">
                            <div className="solution-card">
                                <div className="solution-icon-wrapper">
                                    <i className="fas fa-map-marker-alt solution-icon"></i>
                                </div>
                                <div className="solution-content">
                                    <h3 className="solution-title">Strategic Locations</h3>
                                    <p className="solution-description">
                                        Our facilities are strategically positioned in Jebel Ali Free Zone, giving businesses easy access to Dubai's key trade routes and global markets. This prime location ensures faster turnaround times and seamless connectivity.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Secure & Reliable */}
                        <div className="col-lg-6">
                            <div className="solution-card">
                                <div className="solution-icon-wrapper">
                                    <i className="fas fa-shield-alt solution-icon"></i>
                                </div>
                                <div className="solution-content">
                                    <h3 className="solution-title">Secure & Reliable</h3>
                                    <p className="solution-description">
                                        Advanced safety systems, 24/7 surveillance, and professional handling ensure your goods are protected at every stage. We prioritize security so you can have complete peace of mind.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Smart Inventory Management */}
                        <div className="col-lg-6">
                            <div className="solution-card">
                                <div className="solution-icon-wrapper">
                                    <i className="fas fa-boxes solution-icon"></i>
                                </div>
                                <div className="solution-content">
                                    <h3 className="solution-title">Smart Inventory Management</h3>
                                    <p className="solution-description">
                                        Organized storage solutions combined with modern tracking methods help reduce costs, minimize errors, and improve operational efficiency. Real-time visibility keeps you in control.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Seamless Integration */}
                        <div className="col-lg-6">
                            <div className="solution-card">
                                <div className="solution-icon-wrapper">
                                    <i className="fas fa-sync-alt solution-icon"></i>
                                </div>
                                <div className="solution-content">
                                    <h3 className="solution-title">Seamless Integration</h3>
                                    <p className="solution-description">
                                        Our warehousing services are fully connected with <b>transportation</b> and <b>customs clearance</b> operations, making end-to-end logistics effortless and creating a truly integrated supply chain solution.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Warehouse Features with Images */}
            <section className="warehouse-features-section py-5 bg-light">
                <div className="container">
                    <div className="row mb-5">
                        <div className="col-12 text-center">
                            <h2 className="section-title mb-3">Our Warehouse Facilities</h2>
                            <p className="section-subtitle text-muted">
                                Modern infrastructure designed for diverse storage needs
                            </p>
                        </div>
                    </div>

                    <div className="row g-4">
                        {/* Feature 1 */}
                        <div className="col-lg-4 col-md-6">
                            <div className="feature-card">
                                <div className="feature-image-wrapper">
                                    <img
                                        src="https://images.unsplash.com/photo-1565793298595-6a879b1d9492?w=600&q=80"
                                        alt="Temperature Controlled Storage"
                                        className="feature-image"
                                    />
                                    <div className="feature-overlay">
                                        <i className="fas fa-temperature-low feature-overlay-icon"></i>
                                    </div>
                                </div>
                                <div className="feature-content">
                                    <h4 className="feature-title">Temperature Controlled Storage</h4>
                                    <p className="feature-description">
                                        Wide range from frozen to chilled to dry storage, with precise climate control and monitoring systems.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Feature 2 */}
                        <div className="col-lg-4 col-md-6">
                            <div className="feature-card">
                                <div className="feature-image-wrapper">
                                    <img
                                        src="https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=600&q=80"
                                        alt="Advanced Racking Systems"
                                        className="feature-image"
                                    />
                                    <div className="feature-overlay">
                                        <i className="fas fa-layer-group feature-overlay-icon"></i>
                                    </div>
                                </div>
                                <div className="feature-content">
                                    <h4 className="feature-title">Advanced Racking Systems</h4>
                                    <p className="feature-description">
                                        Optimized storage layouts with state-of-the-art racking to maximize space utilization and accessibility.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Feature 3 */}
                        <div className="col-lg-4 col-md-6">
                            <div className="feature-card">
                                <div className="feature-image-wrapper">
                                    <img
                                        src="https://images.unsplash.com/photo-1494412651409-8963ce7935a7?w=600&q=80"
                                        alt="Loading Docks"
                                        className="feature-image"
                                    />
                                    <div className="feature-overlay">
                                        <i className="fas fa-truck-loading feature-overlay-icon"></i>
                                    </div>
                                </div>
                                <div className="feature-content">
                                    <h4 className="feature-title">Multiple Loading Docks</h4>
                                    <p className="feature-description">
                                        Efficient loading and unloading facilities to speed up operations and reduce turnaround time.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Confidence Section */}
            <section className="confidence-section py-5" id="confidence">
                <div className="container">
                    <div className="row align-items-center g-4">
                        {/* Left Image */}
                        <div className="col-lg-6">
                            <div className="confidence-image-wrapper">
                                <img
                                    src={WhyChooseImg}
                                    alt="Triburg Freight Services"
                                    className="confidence-main-image img-fluid rounded shadow"
                                />
                            </div>
                        </div>

                        {/* Right Content */}
                        <div className="col-lg-6">
                            <div className="confidence-content">
                                <h2 className="confidence-title mb-4">
                                    We provide more than space — we provide confidence
                                </h2>
                                <p className="confidence-description mb-4">
                                    With <strong>Triburg Freight Services LLC</strong>, your products are always in the right place, at the right time, ready for the next step in your journey.
                                </p>
                                <p className="confidence-description">
                                    Our commitment goes beyond storage. We become your trusted partner, ensuring seamless operations, cost efficiency, and peace of mind. Because in logistics, it's not just about where your goods are stored — it's about knowing they're in safe, capable hands.
                                </p>
                                <div className="mt-4">
                                    <Link to="/contact" className="btn btn-primary btn-lg">
                                        Get Started Today
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Call to Action Section */}
            <section className="cta-section py-5 bg-primary text-white">
                <div className="container">
                    <div className="row justify-content-center text-center">
                        <div className="col-lg-8">
                            <h2 className="cta-title mb-3">Ready to Optimize Your Warehousing?</h2>
                            <p className="cta-text mb-4">
                                Let us help you streamline your storage and inventory management with solutions designed for your success.
                            </p>
                            <Link to="/contact" className="btn btn-light btn-lg px-5">
                                Contact Us
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
